module.exports = __webpack_public_path__ + "static/img/user7.1c144ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/user7.jpg
// module id = 4L/8
// module chunks = 0